<template lang="">
  <div>
    <svg xmlns="http://www.w3.org/2000/svg" width="53.66" height="53.66" viewBox="0 0 53.66 53.66">
  <g id="Value_Your_Trade" data-name="Value Your Trade" transform="translate(-1115.944 -307.996)">
    <circle id="Ellipse_1081" data-name="Ellipse 1081" cx="26.33" cy="26.33" r="26.33" transform="translate(1116.444 308.496)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    <g id="Group_8609" data-name="Group 8609" transform="translate(1130.203 321.963)">
      <path id="Path_69792" data-name="Path 69792" d="M.5,12.667A12.453,12.453,0,0,1,13.22.5,12.755,12.755,0,0,1,24.834,7.705" transform="translate(-0.5 -0.5)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_905" data-name="Line 905" y2="5.29" transform="translate(24.334 2.116)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_906" data-name="Line 906" x2="5.29" transform="translate(19.044 7.728)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <path id="Path_69793" data-name="Path 69793" d="M1.5,16.962a12.755,12.755,0,0,0,11.614,7.205A12.453,12.453,0,0,0,25.834,12" transform="translate(-0.442 1.225)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_907" data-name="Line 907" y1="5.29" transform="translate(1.058 17.986)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
      <line id="Line_908" data-name="Line 908" x1="5.29" transform="translate(1.058 17.664)" fill="none" :stroke="themeColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1"/>
    </g>
  </g>
</svg>

  </div>
</template>
<script>
export default {
  props: {
    themeColor: {
      type: String,
      default: '#B3B3B3'
    },
    height: {
      type: String,
      default: '53.66px'
    },
    width: {
      type: String,
      default: '53.66px'
    }
  }
}
</script>
<style lang="">

</style>
